/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { ExitingPersistence, FadeIn } from '@atlaskit/motion';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
var gridSize = getGridSize();
var paddingLeft = gridSize * 5;
var expanderStyles = css({
  display: 'flex',
  minWidth: 0,
  maxHeight: 0,
  padding: "0 0 0 ".concat(paddingLeft, "px"),
  justifyContent: 'center',
  flex: '1 1 100%',
  flexDirection: 'column',
  transition: "max-height 0.3s"
});
var expandedStyles = css({
  maxHeight: 150
});

var Expander = function Expander(_ref) {
  var children = _ref.children,
      isExpanded = _ref.isExpanded,
      testId = _ref.testId;
  // Need to always render the ExpanderInternal otherwise the
  // reveal transition doesn't happen. We can't use CSS animation for
  // the the reveal because we don't know the height of the content.
  return jsx("div", {
    "aria-hidden": !isExpanded,
    css: [expanderStyles, isExpanded && expandedStyles],
    "data-testid": testId && "".concat(testId, "-expander")
  }, jsx(ExitingPersistence, {
    appear: true
  }, isExpanded && jsx(FadeIn, null, function (props) {
    return jsx("div", props, children);
  })));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc


export default Expander;